import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { InProductTrialsOverlayContentController } from '../controller/InProductTrialsOverlayContentController';
import { InProductTrialsOverlayWindowType } from '../../types/InProductTrialsOverlayWindowType';

export class InProductTrialsOverlayContentWebComponent extends BaseWebComponentElement {
  public controller!: InProductTrialsOverlayContentController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: InProductTrialsOverlayContentController,
    });
  }

  public get inProductTrialsOverlayWindowType(): InProductTrialsOverlayWindowType {
    const inProductTrialsOverlayWindowType = this.getAttribute('inProductTrialsOverlayWindowType');

    return inProductTrialsOverlayWindowType
      ? (inProductTrialsOverlayWindowType as InProductTrialsOverlayWindowType)
      : InProductTrialsOverlayWindowType.ProductTrialsHubNewSection;
  }
}
